import { useTranslations } from '@/hooks/useTranslations'

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { UserDropdown, UserStatus } from '@/constants/user'
import MoreVertIcon from '~icons/dl/more_vert.jsx'
import { useProfileData } from '@/hooks/useProfile'

type ActionDropdownProps = {
  isDefault?: boolean
  status: UserStatus
  onClickDropdownItem: (eventName: UserDropdown) => void
}

export const ActionDropdown = ({ isDefault, status, onClickDropdownItem }: ActionDropdownProps) => {
  const t = useTranslations('common')

  const { profile } = useProfileData()

  if (isDefault && profile?.type !== 'admin') {
    return null
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <div className="flex w-7 h-7 justify-center items-center">
            <MoreVertIcon />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          {/* <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.VIEW)}
          >
            {t('dropdown.view')}
          </DropdownMenuItem> */}
          <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.EDIT)}
          >
            {t('dropdown.edit')}
          </DropdownMenuItem>
          {!isDefault && <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.DELETE)}
          >
            {t('dropdown.delete')}
          </DropdownMenuItem>}
          {!isDefault && <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.STATUS)}
          >
            {status === UserStatus.ACTIVE ? t("dropdown.disable") : t("dropdown.enable")}
          </DropdownMenuItem>}
          {!isDefault && <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.CHANGE_PASSWORD)}
          >
            เปลี่ยนรหัสผ่าน
          </DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
